import en from './locales/en';
import zh from './locales/zh';
import de from './locales/de';
import fr from './locales/fr';
import pt from './locales/pt';
import ru from './locales/ru';
import bn from './locales/bn';
import ja from './locales/ja';
import es from './locales/es';

// 支持的语言
export const SUPPORTED_LANGUAGES = {
  en: 'English',
  zh: '中文',
  de: 'Deutsch',
  fr: 'Français',
  pt: 'Português',
  ru: 'Русский',
  bn: 'বাংলা',
  ja: '日本語',
  es: 'Español',
};

// 翻译文本
const translations = {
  en,
  zh,
  de,
  fr,
  pt,
  ru,
  bn,
  ja,
  es,
};

// 本地存储键名
export const LANGUAGE_KEY = 'app_language';

// 定义翻译对象的类型
// type TranslationValue = string | Record<string, TranslationValue>;

// 获取当前语言
export const getCurrentLanguage = (): string => {
  const savedLanguage = localStorage.getItem(LANGUAGE_KEY);
  if (savedLanguage && Object.keys(SUPPORTED_LANGUAGES).includes(savedLanguage)) {
    return savedLanguage;
  }
  
  // 尝试使用浏览器语言
  const browserLang = navigator.language.split('-')[0];
  if (Object.keys(SUPPORTED_LANGUAGES).includes(browserLang)) {
    return browserLang;
  }
  
  // 默认使用英语
  return 'en';
};

// 设置语言
export const setLanguage = (language: string): void => {
  if (Object.keys(SUPPORTED_LANGUAGES).includes(language)) {
    localStorage.setItem(LANGUAGE_KEY, language);
  }
};

// 获取翻译文本
export const t = (key: string, lang?: string): string => {
  const currentLang = lang || getCurrentLanguage();
  const keys = key.split('.');
  
  try {
    let result: any = translations[currentLang as keyof typeof translations];
    for (const k of keys) {
      result = result[k];
      // 如果在遍历过程中结果变为 undefined，则抛出错误
      if (result === undefined) {
        throw new Error(`Translation key not found: ${key}`);
      }
    }
    
    // 确保结果是字符串
    if (typeof result !== 'string') {
      throw new Error(`Translation value is not a string for key: ${key}`);
    }
    
    return result;
  } catch (error) {
    // 如果找不到翻译，尝试从英语中获取
    if (currentLang !== 'en') {
      try {
        let result: any = translations.en;
        for (const k of keys) {
          result = result[k];
          // 如果在遍历过程中结果变为 undefined，则抛出错误
          if (result === undefined) {
            throw new Error(`Translation key not found in English: ${key}`);
          }
        }
        
        // 确保结果是字符串
        if (typeof result !== 'string') {
          throw new Error(`Translation value is not a string for English key: ${key}`);
        }
        
        return result;
      } catch {
        return key; // 返回原始键名
      }
    }
    return key; // 返回原始键名
  }
};

// 创建i18n上下文
export const createI18nContext = () => {
  const currentLanguage = getCurrentLanguage();
  
  return {
    language: currentLanguage,
    t: (key: string) => t(key, currentLanguage),
    setLanguage: (lang: string) => {
      setLanguage(lang);
      window.location.reload(); // 简单处理：更改语言后重新加载页面
    },
    getSupportedLanguages: () => SUPPORTED_LANGUAGES,
  };
};

export type I18nContextType = ReturnType<typeof createI18nContext>; 